module.exports = __webpack_public_path__ + "static/media/capstone_permissions.813bac00.yaml";